export default {
    GET_COURSE_ACTIVITY_REQUEST: 'COURSE_GET_COURSE_ACTIVITY_REQUEST',
    GET_COURSE_ACTIVITY_SUCCESS: 'COURSE_GET_COURSE_ACTIVITY_SUCCESS',
    DISPOSE: 'COURSE_DISPOSE_STORE',
};
